import FileInputComponent from "react-file-input-previews-base64";
import {FormattedMessage} from "react-intl";
import React, {useRef, useState} from "react";
import FormHelperText from "@material-ui/core/FormHelperText";
import FormFieldError from "../form-field-error/form-field-error";

const ImageFieldComponent = ({
                                 id,
                                 name,
                                 value,
                                 onChange,
                                 label,
                                 imagePreview = true,
                                 accept = "image/*",
                                 multiple,
                                 showOldPreview = false,
                                 intl
}) => {
    const [show, setShow] = useState(false);
    const [isFileSelected, setIsFileSelected] = useState(!!value);
    const recoveredValue = useRef(value);

    return (
        <>
            <FileInputComponent
                inputId={id}
                inputName={name}
                labelText={label}
                imagePreview={imagePreview}
                value={value}
                accept={accept}
                multiple={multiple}
                callbackFunction={data => {
                    setIsFileSelected(!!data);
                    if (data && imagePreview) {
                        setShow(true);
                        var image = new Image();
                        image.onload = () => {
                            const size = { x: image.width, y: image.height };

                            !data || data.length <= 0 ? onChange({}) : onChange({ ...data[0], size });
                        };

                        image.src = data[0].base64;
                    }
                }}
                labelStyle={{ fontSize: 14, marginRight: 20 }}
                buttonComponent={
                    isFileSelected ? (
                        <button type="button">
                            <FormattedMessage id="common.asset.modify" />
                        </button>
                    ) : (
                        <button type="button">
                            <FormattedMessage id="common.asset.upload" />
                        </button>
                    )
                }
            />
            {!showOldPreview && !show && <FormHelperText text={intl.formatMessage({ id: "common.asset.notFound" })} />}
            {showOldPreview && recoveredValue.current && recoveredValue.current === value && (
                <img style={{ height: "30vmin" }} src={value} alt={name} />
            )}
            <FormFieldError name={name} />
        </>
    );
}

export default ImageFieldComponent;
